var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHandledairlines({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 94",
    width: 216,
    height: 94,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "u44 (1)-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #003265 } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer copy 3",
    className: "s0",
    d: "m62.1 81.8q1.6 3.8-0.1 6.1-2 1.9-6 0.8-4-1.1-7.2-4l-7-6.1-27.9 8.2q-0.7 0.2-1.3-0.4l-4.2-5q-0.3-0.2-0.3-0.7 0-0.2 0-0.3 0.1-0.6 0.6-0.9l19.9-12.6-11.1-9.9-7.8 2.7q-0.6 0.2-1.2-0.3l-4.2-3.6q-0.4-0.4-0.4-1 0-0.7 0.5-1l9.7-8.3 7.1-10.7q0.3-0.5 0.9-0.6 0.5-0.1 1 0.3l4.2 3.6q0.4 0.4 0.4 1 0.1 0.2 0 0.3l-1.7 8 11.2 9.9 10.1-21.3q0.3-0.6 0.9-0.8 0.7-0.1 1.1 0.3l5.6 4.9q0.5 0.5 0.4 1.2l-4.9 27.4 6.9 6.1q3.3 2.9 4.8 6.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer copy 4",
    className: "s0",
    d: "m112.4 66.2q-1.8 3.7-4.6 3.9-2.7-0.2-4.6-3.8-1.9-3.7-1.9-8.1l-0.1-9.2-24.8-15.3q-0.7-0.4-0.6-1.3l0.9-6.4q0-0.4 0.3-0.7 0.2-0.2 0.3-0.2 0.5-0.4 1-0.2l22.7 6.4-0.1-14.9-7.1-4q-0.7-0.3-0.7-1.1l-0.1-5.5q0-0.5 0.4-0.9l0.1-0.1q0.5-0.4 1.1-0.3l12.7 1.7 12.6-1.9q0.6-0.1 1.1 0.3 0.4 0.3 0.4 0.9l0.1 5.6q0 0.5-0.4 0.9-0.1 0.2-0.2 0.2l-7.1 4.1 0.1 14.9 22.6-6.7q0.6-0.2 1.2 0.2 0.5 0.4 0.5 1l0.1 7.4q0 0.7-0.6 1.1l-23.6 14.7 0.1 9.2q0 4.4-1.8 8.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer copy",
    className: "s0",
    d: "m163.2 91.8q-4 1.6-6.4-0.2-2-2.1-0.8-6.3 1.1-4.2 4.2-7.6l6.5-7.3-8.5-29.5q-0.3-0.8 0.4-1.5l5.3-4.4q0.3-0.3 0.8-0.3 0.2 0 0.3 0 0.7 0.1 0.9 0.7l13.2 21.1 10.5-11.7-2.7-8.2q-0.3-0.7 0.3-1.4l3.8-4.3q0.4-0.4 1-0.5h0.1q0.6 0.1 1.1 0.5l8.7 10.4 11.2 7.5q0.5 0.3 0.6 1 0.1 0.5-0.3 1.1l-3.9 4.4q-0.4 0.4-1 0.4-0.2 0-0.3 0l-8.4-1.8-10.5 11.7 22.4 10.8q0.6 0.3 0.8 1 0.1 0.7-0.3 1.2l-5.2 5.7q-0.6 0.6-1.3 0.5l-28.9-5.3-6.5 7.3q-3.1 3.4-7.1 5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandledairlines);
export default __webpack_public_path__ + "static/media/handledairlines.1ed449dfab422b6eda5f3d2922628da8.svg";
export { ForwardRef as ReactComponent };